<template>
  <div class="login-container">
    <!--[if lte IE 8]>
    <div>
    <h4>温馨提示：</h4>
    <p>你使用的浏览器版本过低, 为了获得更好的浏览体验, 我们强烈建议您 <a href="http://browsehappy.com" target="_blank">升级</a>
      到最新版本的IE浏览器, 或者使用较新版本的 Chrome、Firefox、Safari 等. </p>
    </div>
    <![endif]-->

    <!-- BACKGROUND IMAGE -->
    <!--===================================================-->
    <div class="login-bg-img login-bg-img-balloon"></div>

    <!-- HEADER -->
    <!--===================================================-->
    <div class="login-header">
      <div class="login-header-title">
        <a>
          <span>{{ projectName }}</span>
        </a>
      </div>
    </div>
    <!--===================================================-->

    <!-- LOGIN FORM -->
    <!--===================================================-->
    <div class="login-body">
      <div class="login-body-panel">
        <div class="loginTips">
          <i class="el-icon-info" style="color:#409EFF">&nbsp;</i>
          还没有账号？立即点击下方 <span style="color: #409EFF;">【在线办理印章】</span> 按钮，快速注册并办理电子印章，开启安全高效的电子合同服务！
        </div>
        <div class="panel-body">
          <div class="login-tabs">
            <p :class="activeTabs == '1' ? 'login-tabs-cell activeTabsClass' : 'login-tabs-cell'"
              @click="activeTabs = '1'">
              用户名登录</p>
            <p :class="activeTabs == '2' ? 'login-tabs-cell activeTabsClass' : 'login-tabs-cell'"
              @click="activeTabs = '2'">
              验证码登录</p>
          </div>
          <el-form v-if="activeTabs == '1'" label-position="top" id="form" :model="loginInfo" status-icon
            class="demo-ruleForm">
            <el-form-item label="用户名" prop="uname">
              <el-input type="text" v-model="loginInfo.uname" name="loginName" placeholder="请输入登录账号"
                @focus="focusState.uname = true" @blur="focusState.uname = false">
                <img slot="prefix"
                  :src="focusState.uname ? require('../../../static/img/kefu/accountAct.png') : require('../../../static/img/kefu/account.png')" />
              </el-input>
            </el-form-item>
            <el-form-item label="密码" prop="upwd">
              <el-input type="password" v-model="loginInfo.upwd" name="password" placeholder="请输入登录密码" ref="password"
                @focus="focusState.upwd = true" @blur="focusState.upwd = false">
                <img slot="prefix"
                  :src="focusState.upwd ? require('../../../static/img/kefu/loginPwdAct.png') : require('../../../static/img/kefu/loginPwd.png')" />
              </el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="vrfc" v-if="loginVerify">
              <!-- <el-input type="text" style="display: inline-block;width: 355px" name="validateCode" placeholder="验证码"
                v-model="loginInfo.vrfc"></el-input> -->
                <el-input type="text" style="display: inline-block;width: 355px" name="vrfc"
                placeholder="验证码" v-model="loginInfo.vrfc" @focus="focusState.vrfc = true"
                @blur="focusState.vrfc = false">
                <img slot="prefix" :src="focusState.vrfc ? require('../../../static/img/kefu/codeLoginAct.png') :
                  require('../../../static/img/kefu/codeLogin.png')" />
              </el-input>
              <span class="input-group-addon"
                style="width:80px;padding: 0; display: inline-block; cursor: pointer;height:40px;"
                @click="getLoginCode">
                <img style=" vertical-align: middle;width: 100%;" :src="loginInfo.vrfcSrc" alt />
              </span>
            </el-form-item>
            <div class="forgetPwd">
              忘记密码了？ <span style="color: #409EFF;" @click="skipSetPwd">点击此处</span>
            </div>
            <el-form-item>
              <el-button type="primary" :class="{ disabled: loginInfo.loginBtnDisabled }" id="login"
                @click.prevent="login">
                <img src="../../../static/img/login_btn.png" />
                {{ loginInfo.loginBtnText }}
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="success" id="login1" @click="toUmspPath">
                <img src="../../../static/img/login_seal.png" />
                在线办理印章
              </el-button>
            </el-form-item>
          </el-form>

          <el-form v-if="activeTabs == '2'" label-position="top" id="form1" :model="codeLogin" status-icon
            class="demo-ruleForm" :action="path" method="post">
            <el-form-item label="邮箱/手机号" prop="uname">
              <el-input type="text" v-model="codeLogin.loginName" name="loginName" placeholder="请输入邮箱/手机号"
                @focus="focusState.uname = true" @blur="focusState.uname = false">
                <img slot="prefix"
                  :src="focusState.uname ? require('../../../static/img/kefu/accountAct.png') : require('../../../static/img/kefu/account.png')" />
              </el-input>
            </el-form-item>
            <el-form-item label="图片验证码" prop="imgverifyCode" style="position: relative;">
              <div>
                <el-input type="text" v-model="codeLogin.imgverifyCode" placeholder="请输入图片验证码"
                @focus="focusState.imgVerifyCode = true" @blur="focusState.imgVerifyCode = false">
                <img slot="prefix"
                  :src="focusState.imgVerifyCode ? require('../../../static/img/kefu/imgCodeAct.png') : require('../../../static/img/kefu/imgCode.png')" />
              </el-input>
              <img style="position: absolute;right: 2px;top: 5px;" :src="verifySrc" alt="验证码"
                @click="vrfcRefreshCode" />
              </div>
            </el-form-item>
            <el-form-item label="验证码" prop="vrfc">
              <el-input type="text" style="display: inline-block;float:left;width: 68%;" name="validateCode"
                placeholder="验证码" v-model="codeLogin.validateCode" @focus="focusState.codeLoginName = true"
                @blur="focusState.codeLoginName = false">
                <img slot="prefix" :src="focusState.codeLoginName ? require('../../../static/img/kefu/codeLoginAct.png') :
                  require('../../../static/img/kefu/codeLogin.png')" />
              </el-input>
              <el-button type="primary" style="float: right" v-if="!codeShow" @click="get_code">发送验证码
              </el-button>
              <el-button type="primary" style="float: right" v-if="codeShow">{{ content }}
              </el-button>
            </el-form-item>
            <div class="forgetPwd">
              忘记密码了？ <span style="color: #409EFF;" @click="skipSetPwd">点击此处</span>
            </div>
            <el-form-item>
              <el-button type="primary" :class="{ disabled: loginInfo.loginBtnDisabled }" id="login1"
                @click="loginCode">
                <img src="../../../static/img/login_btn.png" />
                {{ loginInfo.loginBtnText }}
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="success" id="login1" @click="toUmspPath">
                <img src="../../../static/img/login_seal.png" />
                在线办理印章
              </el-button>
            </el-form-item>
          </el-form>
          <div class="buttonTips">
            点击上方按钮，快速办理电子印章，立即体验电子合同服务
          </div>

          <div class="download-and-docs">
            <!-- 下载客户端 -->
            <div style="margin-bottom: 12px;">
              <download-customer></download-customer>
            </div>
            <div class="docs-right">
              <div class="doc-link" style="flex: 1;" @click="downloadOperational(0)">
                <img src="../../../static/img/login_step.png" />
                <span>操作手册</span>
              </div>
              <div class="doc-link" style="width: 136px;" @click="downloadOperational(1)">
                <img src="../../../static/img/login_data.png" />
                <span>印章办理材料</span>
              </div>
            </div>
          </div>
          <div v-if="hotlinePhone && hotlinePhone.length > 0" class="information">
            <div class="infoLabel">咨询热线：</div>
            <div class="container">
              <div v-for="(item, index) in hotlinePhone" :key="index" v-show="index < 3" class="items">{{ item }}</div>
              （工作日 9:00-18:00）
            </div>
          </div>
          <div v-if="QQInquiry && QQInquiry.length > 0" class="information">
            <div class="infoLabel">QQ群：</div>
            <div class="container qq-container">
              <div v-for="(item, index) in QQInquiry" :key="index" class="items" v-show="index < 6">{{ item }}</div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- 登录失败弹框 -->
    <el-dialog :visible.sync="loginFailVisible" width="640px" custom-class="login-fail-dialog" center>
      <div class="login-fail-content">
        <div class="login-fail-icon">
          <i class="el-icon-circle-close"></i>
        </div>
        <h2 class="login-fail-title">{{ loginFailMsg }}</h2>
        <div class="login-fail-tips" >
          <ul>
            <li>1.若您尚无账号，点击下方 <span class="link-text" @click="toUmspPath">【在线办理印章】</span> 按钮，即可快速注册并办理电子印章。</li>
            <li>2.若已有账号，请确认登录名与密码填写无误；也可依据经办人信息，点击 <span class="link-text" @click="handleRecoverAccount">【找回账号】</span> 找回账号。</li>
            <li>3.若忘记密码，点击 <span class="link-text" @click="skipSetPwd">【忘记密码】</span> 按钮，进行密码找回或重置操作。</li>
          </ul>
        </div>
        <div class="login-fail-btns">
          <el-button type="success" @click="toUmspPath" class="seal-btn">
            <img src="../../../static/img/login_seal2.png" /> 在线办理印章
          </el-button>
          <el-button type="primary" plain @click="skipSetPwd" class="seal-btn">
           <img src="../../../static/img/login_key.png" />  忘记密码
          </el-button>
          <el-button type="primary" @click="handleRecoverAccount">找回账号</el-button>
          <el-button @click="closeLoginFail">关闭提示</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
  <!--===================================================-->

  <!--<footer id="footer" class="navbar-fixed-bottom login-footer">-->
  <!--Copyright © Easysign.cn. All rights reserved. 北京一签通网络科技有限公司. 京ICP备05053630号- 2-->
  <!--</footer>-->
</template>

<script type="text/babel">
import login from "../../assets/js/login";
import api from "@/assets/js/api";
import { Decrypt, Encrypt } from "../../assets/js/utils";
import DownloadCustomer from "../common/DownloadCustomer.vue";

export default {
  components: { DownloadCustomer },
  data() {
    return {
      loginInfo: {
        loginBtnText: this.$t("loginComponent.login"),
        uname: "",
        upwd: "",
        vrfc: "",
        errorMessage: "",
        vrfcSrc: "",
        loginBtnDisabled: ""
      },
      verifySrc: "",
      codeLogin: {
        loginName: "",
        smsCodeLogin: "1",
        validateCode: "",
        imgverifyCode: ""
      },
      outTime: 60,
      content: "60s后重新发送",
      codeShow: false,
      path: "",
      activeTabs: "1",
      loginVerify: false,
      hotlinePhone: [], //技术支持电话
      QQInquiry: [], //QQ群
      projectName: "",
      codeuuid: "", //
      canClick: true, //用户名错误时防重复
      loginFailVisible: false, //登录失败弹框
      loginFailMsg: "", //登录失败信息
      resetPswUrl: "",
      recoverAccount: "",
      // 表单输入框焦点状态
      focusState: {
        uname: false,
        upwd: false,
        codeLoginName: false,
        imgVerifyCode: false,
        vrfc:false,
      },
      isComposing: false, // 是否正在输入法组合中（解决360浏览器无法输入中文问题）
    };
  },
  watch: {
    activeTabs: function() {
      if (this.activeTabs == "1") {
        this.loginInfo = {
          loginBtnText: this.$t("loginComponent.login"),
          uname: "",
          upwd: "",
          vrfc: "",
          errorMessage: "",
          vrfcSrc: "",
          loginBtnDisabled: ""
        };
        this.getLoginCode();
      } else {
        this.codeLogin = {
          loginName: "",
          smsCodeLogin: "1",
          validateCode: "",
          imgverifyCode: ""
        };
        this.verifySrc = api.menu.getImgVerifyCode("2");
      }
    }
  },
  beforeCreate() {},
  async mounted() {
    this.$xLoading.close();
    this.getLoginCode();
    // this.vrfcRefresh();
    // this.vrfcRefreshCode();
    var _this = this;
    $(document).keydown(function(event) {
      if (event.keyCode == 13) {
        if (_this.activeTabs == "1") {
          _this.login();
        }
        if (_this.activeTabs == "2") {
          _this.loginCode();
        }
      }
    });
    this.getOneSysParameterConfig();
    api.menu.commonPathGetOneSysParameter("reset_password_url").then(res => {
      if (res.data.code == "0") {
        this.resetPswUrl = res.data.data.value;
      }
    });
    // 找回账号
    api.menu.commonPathGetOneSysParameter("recover_account").then(res => {
      if (res.data.code == "0") {
        this.recoverAccount = res.data.data.value;
      }
    });
    api.menu.commonPathGetOneSysParameter("inquiryTelephone").then(res => {
      if (res.data.code == "0") {
        const value = res.data.data.value;
        if (value != "0") {
          this.hotlinePhone = value.split(",").filter(item => item);
        }
        console.log(this.hotlinePhone, "QQ群");
      }
    });
    api.menu.commonPathGetOneSysParameter("QQInquiry").then(res => {
      if (res.data.code == "0") {
        const value = res.data.data.value;
        if (value != "0") {
          this.QQInquiry = value.split(",").filter(item => item);
        }
      }
    });
    api.menu.getProjectName().then(res => {
      // console.log(res, "????");
      this.projectName = res.data.data.projectName;
    });
  },
  methods: {
    // 忘记密码
    skipSetPwd() {
      window.open(this.resetPswUrl);
    },
    downloadOperational(type) {
      window.location.href = `/contract/api/contract/common/downloadOperational?type=${type}`;
    },
    handleRecoverAccount() {
      window.open(this.recoverAccount);
    },
    showLoginFail(msg) {
      this.loginFailMsg = msg || "用户名或密码错误，请检查后重试。";
      this.loginFailVisible = true;
    },
    // 处理输入框失焦，解决360浏览器输入中文时失焦导致无法输入的问题
    handleBlur(field) {
      // 如果正在输入法组合中，不更新焦点状态
      if (this.isComposing) return;
      this.$nextTick(() => {
        if (this.isComposing) return;
        this.focusState[field] = false;
      });
    },
    closeLoginFail() {
      this.loginFailVisible = false;
    },
    downloadClient() {
      api.menu.downloadClient().then(res => {
        if (res.data.code == 0) {
          window.open(res.data.message);
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
            center: true
          });
        }
      });
    },
    // 业务办理平台地址返回接口
    toUmspPath() {
      api.menu.toUmspPath().then(res => {
        if (res.data.code == 0) {
          window.location.href = res.data.data;
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
            center: true
          });
        }
      });
    },
    //获取登录验证码
    getLoginCode: function() {
      api.menu.getLoginVerifyCode().then(res => {
        // console.log(res, "?");
        this.loginInfo.vrfcSrc = res.data.data.codeimg;
        this.loginInfo.codeuuid = res.data.data.codeuuid;
      });
    },

    get_code() {
      if (!this.canClick) {
        return false;
      }
      this.canClick = false;
      let _this = this;
      if (this.codeLogin.loginName == "") {
        this.$message({
          message: "请输入邮箱/手机号",
          type: "error",
          center: true
        });
        this.canClick = true;
        return false;
      }
      if (_this.codeLogin.imgverifyCode == "") {
        this.$message({
          message: "请输入图片验证码",
          type: "error",
          center: true
        });
        this.canClick = true;
        return false;
      }
      let loginNameVerify = new Promise(function(reslove, reject) {
        api.menu.loginNameIsExist(_this.codeLogin.loginName).then(res => {
          if (res.data.code == "0") {
            reslove(res);
          } else {
            reject(res);
          }
        });
      });

      loginNameVerify
        .then(res => {
          let info = {
            type: "",
            receiving: this.codeLogin.loginName,
            zhCode: this.codeLogin.imgverifyCode,
            zhCodeType: "2"
          };
          //验证码接收账号(type=1 时为手机号，type=2时为邮箱)
          var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
          var regEmail = /^[\w\.-]+@[\w\.-]+\.\w{2,}$/;
          if (reg.test(_this.codeLogin.loginName)) {
            info.type = "1";
          }
          if (regEmail.test(_this.codeLogin.loginName)) {
            info.type = "2";
          }
          if (
            !reg.test(_this.codeLogin.loginName) &&
            !regEmail.test(_this.codeLogin.loginName)
          ) {
            _this.$message.warning("请输入正确的邮箱/手机号");
            _this.canClick = true;
            return false;
          }
          api.menu.sendVerifyCode(info).then(res => {
            if (res.data.code == "0") {
              _this.$message.success({
                message: res.data.message,
                center: true
              });
              _this.codeShow = true;
              // 保存定时器引用，便于清除
              _this.clockTimer = window.setInterval(() => {
                _this.outTime--;
                _this.content = _this.outTime + "s后重新发送";
                if (_this.outTime == 0) {
                  window.clearInterval(_this.clockTimer);
                  _this.codeLogin.imgverifyCode = "";
                  _this.vrfcRefreshCode();
                  _this.outTime = 60;
                  _this.content = "60s后重新发送";
                  _this.codeShow = false;
                  _this.canClick = true;
                }
              }, 1000);
            } else {
              _this.$message.error({
                message: res.data.message,
                center: true
              });
              _this.codeLogin.imgverifyCode = "";
              _this.vrfcRefreshCode();
              _this.canClick = true;
            }
          });
        })
        .catch(err => {
          _this.$message.error((err.data && err.data.message) || "验证失败");
          _this.canClick = true;
        });
    },
    loginCode: function() {
      if (this.codeLogin.loginName == "") {
        this.$message({
          message: "请输入登录名",
          type: "error",
          center: true
        });
        return false;
      }
      if (this.codeLogin.validateCode == "") {
        this.$message({
          message: "请输入验证码",
          type: "error",
          center: true
        });
        return false;
      }
      api.menu.login(this.codeLogin).then(res => {
        // console.log(res);
        if (res.data.code == "0") {
          sessionStorage.setItem("token", res.data.data.access_token);
          this.$router.push("/index");
        } else {
          this.showLoginFail("登录失败，请检查后重试。");
          return false;
        }
      });
    },

    goLink: function(url) {
      if (url === "/rp") {
        let UMSPChgPsw = sessionStorage.getItem("UMSPChgPsw");
        UMSPChgPsw ? window.open(UMSPChgPsw, "_blank") : this.$router.push(url);
        // this.$router.push(url);
      }
    },
    vrfcRefresh: function() {
      this.loginInfo.vrfcSrc = login.getVerifyCodeUrl();
    },
    login: function() {
      var _this = this;
      // console.log(this.loginInfo);
      this.beforeLogin();
      var a, b, c;
      a = this.loginInfo.uname === "" ? 1 : 2;
      b = this.loginInfo.upwd === "" ? 1 : 2;
      c = this.loginInfo.vrfc === "" ? 1 : 2;
      if (a !== 2) {
        this.loginInfo.errorMessage = "请输入用户名!";
        this.afterLoginFail();
        return false;
      }
      if (b !== 2) {
        this.loginInfo.errorMessage = "请输入密码!";
        this.afterLoginFail();
        return false;
      }
      if (c !== 2 && this.loginVerify) {
        this.loginInfo.errorMessage = "验证码不能为空!";
        this.afterLoginFail();
        return false;
      }

      // let getAesKey = new Promise(function(reslove, reject) {
      //   api.menu.getAesKey().then(res => {
      //     if (res.data.code == "0") {
      //       reslove(res);
      //     } else {
      //       reject(res);
      //     }
      //   });
      // });
      // getAesKey.then(res => {
      //   let key = res.data.message;
      //   this.loginInfo.upwd = Encrypt(this.loginInfo.upwd, key);
      // login.loginReq(_this.loginInfo).then(result => {
      //     $("#form")[0].reset();
      //     if (!result.data.ok) {
      //       if (result.data.code != 999) {
      //         _this.loginInfo.errorMessage = result.message;
      //       }
      //       else {
      //         //_this.loginInfo.errorMessage = "验证码失效 , 请刷新验证码重试";
      //         _this.loginInfo='';
      //         _this.vrfcRefresh();
      //       }
      //       _this.loginInfo.errorMessage = result.data.message;
      //       _this.afterLoginFail(result.data.code);
      //     }
      //     else {
      //       _this.afterLoginSuccess();
      //       _this.$router.push("/index");
      //     }
      //   }).catch( error=> {
      //      _this.$message({
      //         message: "登录失败 , 请稍后重试",
      //         type: "error",
      //         center: true
      //       });
      //   });
      // })
      this.loginInfo.upwd = Encrypt(
        this.loginInfo.upwd,
        sessionStorage.getItem("aesKey")
      );
      console.log(_this.loginInfo, "login");
      login
        .loginReq(_this.loginInfo)
        .then(result => {
          $("#form")[0].reset();
          if (!result.data.ok) {
            if (result.data.code != 999) {
              _this.loginInfo.errorMessage = result.message;
            } else {
              //_this.loginInfo.errorMessage = "验证码失效 , 请刷新验证码重试";
              _this.loginInfo = "";
              _this.getLoginCode();
            }
            _this.getLoginCode();
            _this.loginInfo.errorMessage = result.data.message;
            _this.showLoginFail(
              result.data.message || "用户名或密码错误，请检查后重试。"
            );
            _this.afterLoginFail(result.data.code);
          } else {
            _this.afterLoginSuccess();
            sessionStorage.setItem("token", result.data.data.access_token);
            _this.$router.push("/index");
          }
        })
        .catch(error => {
          _this.getLoginCode();
          _this.showLoginFail("登录失败，请稍后重试。");
        });
    },
    beforeLogin: function() {
      this.loginInfo.loginBtnDisabled = true;
      this.loginInfo.loginBtnText = "登 录 中...";
    },
    /**
     * 登录失败后将用户按钮置为可用
     */
    afterLoginFail: function(code) {
      // 验证码错误或者密码错误 5 次才刷新
      if ("0001" === code || "0003" === code) {
        this.loginInfo.vrfc = "";
        this.loginInfo.upwd = "";
        this.getLoginCode();
      }
      if ("0002" === code) {
        this.loginInfo.uname = "";
        this.loginInfo.upwd = "";
        this.loginInfo.vrfc = "";
        this.getLoginCode();
      }
      if ("0007" === code) {
        this.loginInfo.vrfc = "";
        this.getLoginCode();
      }

      this.loginInfo.loginBtnDisabled = false;
      this.loginInfo.loginBtnText = "登  录";
    },
    /**
     * 登录成功之后，将登录按钮改为跳转中
     */
    afterLoginSuccess: function() {
      sessionStorage.clear();
      this.loginInfo.loginBtnDisabled = true;
      this.loginInfo.loginBtnText = "跳 转 中...";
    },
    //刷新图片验证码
    vrfcRefreshCode() {
      this.verifySrc = api.menu.getImgVerifyCode("2");
    },
    //获取系统配置/登录是否校验
    getOneSysParameterConfig() {
      api.menu.loginCheckVerifyCode().then(res => {
        if (res.data.message === "1") {
          this.loginVerify = true;
        } else {
          this.loginVerify = false;
        }
        // console.log(res, "是否校验");
      });
    }
  },
  destroyed: function() {
    // $(document).onkeydown=function(){};
    $(document).unbind("keydown");
  }
  /*mounted:function () {
    document.getElementsByTagName('title')[0].innerHTML = "合同管理系统"
  }*/
};
</script>

<style scoped>
.container {
  display: flex;
  flex-wrap: wrap;
}
.qq-container .items:not(:last-child) {
  margin-right: 20px;
}

.information {
  font-size: 14px;
  display: flex;
  justify-content: center;
  margin-top: 18px;
}

.infoLabel {
  width: 80px;
  font-weight: bolder;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
  -webkit-text-fill-color: rgba(85, 85, 85, 1) !important;
}

/* 登录 Start */
login-container .btn-primary {
  background: #237bdf;
}

login-container .btn-primary:active:hover {
  background: #237bdf;
  box-shadow: none;
}

login-container .btn-primary:hover,
.btn-primary:active {
  background: #237bdf;
}

login-container .form-control:active:hover:focus {
  border: 1px solid #ccc !important;
}

.login-container {
  background-color: #212124;
  color: #515151;
  font-size: 12px;
  padding: 0;
  vertical-align: middle;
  width: auto;
  min-height: 100vh;
}

.login-bg-img {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.8;
  background: no-repeat fixed center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

/*背景图片*/
.login-bg-img-balloon {
  background-image: url("../../../static/img/bg-img-6.jpg");
}

.login-header {
  position: relative;
  /*background-color: rgba(0, 0, 0, 0.1);*/
  font-weight: 400;
  font-size: 24px;
  padding: 50px 0 24px;
  text-align: center;
}

.login-header .login-header-title .brand-icon {
  width: 60px;
  height: 60px;
}

.login-header-title a {
  letter-spacing: 2px;
  color: #ffffff;
}

.login-header-title a:hover {
  color: #ffffff;
}

.login-body {
  padding: 15px 15px;
  position: relative;
  margin-left: 5px;
  margin-right: 5px;
}

.login-body-panel {
  width: 780px;
  min-height: 680px;
  padding: 16px;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  background-color: #fff;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.2);
  border-radius: 16px;
}

.login-body-panel .panel-body {
  padding: 0 154px;
  box-sizing: border-box;
}

.login-body-panel .loginTips {
  width: 100%;
  background-color: #eaf2ff;
  border-radius: 4px;
  text-align: center;
  height: 48px;
  line-height: 48px;
}

.login-body-panel .forgetPwd {
  margin: 16px 0 24px;
  cursor: pointer;
}

.buttonTips {
  text-align: center;
  padding-bottom: 16px;
  color: #666666;
  border-bottom: 1px dashed #dcdcdc;
}

.download-and-docs {
  margin-top: 16px;
  padding: 0 10px;
}

.docs-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.docs-right .doc-link {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.docs-right .doc-link > img {
  width: 20px;
  margin-right: 8px;
  flex-shrink: 0;
}

.docs-right .doc-link > span {
  color: #409eff;
  white-space: nowrap;
  font-size: 12px;
}

.docs-right .doc-split-line {
  width: 1px;
  height: 16px;
  background-color: #a4b0c8;
  margin: 0 20px;
}

.login-body-panel-head {
  margin-bottom: 20px;
  /*margin-left: 50px;*/
  font-size: 22px;
  color: #237bdf;
  letter-spacing: 2px;
  text-align: center;
}

.login-footer {
  font-size: 15px;
  padding-bottom: 10px;
  color: #e0e0e0;
}

.login-footer a {
  color: #e0e0e0;
}

.login-footer a:hover {
  color: #ffffff;
}

.login-mar-rgt {
  margin-right: 15px;
}

.login-mar-lft {
  margin-left: 15px;
}

.input-group .input-group-addon {
  border-radius: 4px 0 0 4px;
}

.form-control {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  position: relative;
  z-index: 2;
  float: left;
  width: 100%;
  margin-bottom: 0;
}

.login-icon {
  padding-left: 18px;
  padding-right: 18px;
  border-radius: 4px;
}

.verify-code {
  margin-bottom: 10px;
}

.login-user-img {
  background-image: url("../../../static/img/lnavha_pic.png");
  height: 80px;
  width: 80px;
  background-size: 80px;
  margin: 10px auto;
}

#login {
  text-align: center;
  display: inline-block;
  width: 100%;
  font-size: 16px;
  line-height: 24px;
  font-weight: bolder;
}

#login1 {
  text-align: center;
  display: inline-block;
  width: 100%;
  font-size: 16px;
  line-height: 24px;
  font-weight: bolder;
}

#footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
}

/*登录 End */

/* 切换登录方式 */
.login-tabs {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
}

.login-tabs .login-tabs-cell {
  border-bottom: 1px solid #eaf2ff;
  width: 50%;
  padding-bottom: 8px;
  padding-top: 24px;
  font-size: 16px;
  color: #666666;
  cursor: pointer;
  text-align: center;
}

.activeTabsClass {
  border-bottom: 2px solid #409eff !important;
  font-weight: bold;
  color: #409eff !important;
}

.minLink {
  color: #868686;
  font-size: 14px;
}

.minLink > div {
  display: inline-block;
  float: left;
  cursor: default;
}

.minLink > div:hover {
  color: #3399ff;
}

.code {
  display: inline-block;
  width: 32%;
  height: 40px;
  line-height: 40px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  border-radius: 4px;
}

.panel-body .el-input__prefix img {
  width: 16px;
  height: 16px;
  margin-top: 12px;
  margin-left: 4px;
}
</style>
<style>
.panel-body .el-form--label-top .el-form-item__label {
  padding: 0;
}

.panel-body .el-form-item {
  margin-bottom: 10px;
}

.login-fail-dialog .el-dialog__body {
  padding: 30px 30px 20px;
}

.login-fail-content {
  text-align: center;
}

.login-fail-icon {
  margin-bottom: 24px;
}

.login-fail-icon .el-icon-circle-close {
  font-size: 56px;
  color: #f56c6c;
}

.login-fail-title {
  font-size: 20px;
  color: #333;
  margin: 0 0 24px;
  font-weight: bold;
}

.login-fail-msg {
  font-size: 14px;
  color: #999;
  margin: 0 0 16px;
}

.login-fail-tips {
  text-align: left;
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 20px;
}

.login-fail-tips ul {
  margin: 0;
  padding-left: 0;
}

.login-fail-tips ul li {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
  list-style: none;
}

.login-fail-tips .link-text {
  color: #409eff;
  cursor: pointer;
}

.login-fail-tips .link-text:hover {
  text-decoration: underline;
}

.login-fail-btns {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.login-fail-btns .el-button {
  min-width: 120px;
  padding: 9px 15px;
}

.login-fail-btns .el-button [class*="el-icon-"] {
  margin-right: 4px;
}

.login-fail-btns .el-button.seal-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.login-fail-btns .el-button.seal-btn img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue